/* ktob-login-hub.js — login error banner 20260917 */
(function () {
  function stripShopLoginAttrs(form) {
    if (!form) return;
    form.removeAttribute('data-login-with-shop-sign-in');
    form.removeAttribute('data-login-with-shop-sign-up');
  }

  function showRecoverSuccess(successBanner) {
    if (!successBanner) return;
    successBanner.hidden = false;
    successBanner.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var url = new URL(window.location.href);
    if (url.searchParams.get('recover') !== 'sent') {
      url.searchParams.set('recover', 'sent');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }
  }

  function initLoginHub(root) {
    if (!root || root.getAttribute('data-ktob-login-hub-init') === '1') return;
    root.setAttribute('data-ktob-login-hub-init', '1');

    var modal = document.querySelector('[data-ktob-recover-modal]');
    var openBtn = root.querySelector('[data-ktob-open-recover]');
    var closeBtns = document.querySelectorAll('[data-ktob-close-recover]');
    var successBanner = root.querySelector('[data-ktob-recover-success]');
    var passwordToggle = root.querySelector('[data-ktob-password-toggle]');
    var passwordInput = root.querySelector('#KtobCustomerPassword');
    var loginForm = root.querySelector('form[action*="/account/login"]');
    var recoverForm = modal ? modal.querySelector('form[action*="/account/recover"]') : null;
    var recoverApi = window.ktobRecoverPassword;

    if (loginForm) {
      stripShopLoginAttrs(loginForm);
    }
    if (window.ktobDisableAltLogin && window.ktobDisableAltLogin.neutralize) {
      window.ktobDisableAltLogin.neutralize(root);
    }

    if (window.ktobLoginReturn && window.ktobLoginReturn.injectReturnToIntoForm) {
      window.ktobLoginReturn.injectReturnToIntoForm(loginForm);
    }

    var pageParams = new URLSearchParams(window.location.search);
    if (pageParams.get('recover') === 'sent' && successBanner) {
      successBanner.hidden = false;
    }

    var errorBanner = root.querySelector('[data-ktob-login-error]');
    var errorCode = pageParams.get('login_error');
    if (errorBanner && errorCode) {
      var errorMsg = errorBanner.querySelector('[data-ktob-login-error-msg]');
      var messages =
        (window.ktobLoginReturn && window.ktobLoginReturn.LOGIN_ERROR_MESSAGES) || {};
      if (errorMsg) {
        errorMsg.textContent =
          messages[errorCode] ||
          messages.credentials ||
          'メールアドレスまたはパスワードが正しくありません。';
      }
      errorBanner.hidden = false;
      errorBanner.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    var emailInput = root.querySelector('#KtobCustomerEmail');
    var loginEmail = pageParams.get('login_email');
    if (emailInput && loginEmail) {
      var safeEmail =
        window.ktobLoginReturn && window.ktobLoginReturn.isSafeLoginEmail
          ? window.ktobLoginReturn.isSafeLoginEmail(loginEmail)
          : loginEmail;
      if (safeEmail) emailInput.value = safeEmail;
    }

    function openModal() {
      if (!modal) return;
      modal.hidden = false;
      if (recoverApi) recoverApi.showErrors(modal, []);
      var emailInput = root.querySelector('#KtobCustomerEmail');
      var recoverEmail = root.querySelector('#KtobRecoverEmail');
      if (emailInput && recoverEmail && emailInput.value) {
        recoverEmail.value = emailInput.value;
      }
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
    }

    if (openBtn) openBtn.addEventListener('click', openModal);
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    if (recoverForm && recoverApi) {
      recoverForm.addEventListener('submit', function (event) {
        event.preventDefault();
        recoverApi.submitForm({
          form: recoverForm,
          errorHost: modal,
          proxyUrl: root.getAttribute('data-proxy-url') || '/apps/b2b-gate',
          registerUrl: root.getAttribute('data-register-url') || '/pages/register',
          onSuccess: function () {
            closeModal();
            showRecoverSuccess(successBanner);
          },
          onError: function (errors, check) {
            recoverApi.showErrors(modal, errors || []);
            if (check && check.status === 'not_found') {
              var registerUrl = root.getAttribute('data-register-url') || '/pages/register';
              var host = modal.querySelector('[data-ktob-recover-errors]');
              if (host && !host.querySelector('[data-ktob-recover-register-link]')) {
                var p = document.createElement('p');
                p.setAttribute('data-ktob-recover-register-link', '');
                p.style.margin = '0.75rem 0 0';
                var a = document.createElement('a');
                a.href = registerUrl;
                a.textContent = '新規アカウント申請画面へ';
                p.appendChild(a);
                host.appendChild(p);
              }
            }
          },
        });
      });
    }

    if (passwordToggle && passwordInput) {
      passwordToggle.addEventListener('click', function () {
        var isPassword = passwordInput.type === 'password';
        passwordInput.type = isPassword ? 'text' : 'password';
        passwordToggle.textContent = isPassword ? '非表示' : '表示';
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ktob-login-hub-root]').forEach(initLoginHub);
  });
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-ktob-login-hub-root]');
    if (root) initLoginHub(root);
  });
})();
